import './scroll-to-top.scss';

window.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('goTopLink');
  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    // @DEV : Chrome ne prends pas en charge le behaviour smooth pour l'instant. On utilise donc jQuery.
    // document.querySelector('#page-wrapper').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    jQuery("html, body").animate({ scrollTop: "0" });
  });
});

window.onscroll = function (e) {
  let scrollPos = window.scrollY;
  if (this.oldScroll > this.scrollY && scrollPos > 200) {
    $('div#goTop').fadeIn();
  } else {
    $('div#goTop').fadeOut();
  }
  this.oldScroll = this.scrollY;
}
